module.exports = __webpack_public_path__ + "img/infografia_02.79aebd05.png";